module.exports = __webpack_public_path__ + "img/nuvola_1.79dfbe45.png";